import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deprecationTitle: {
		id: 'servicedesk.automation.summary.v2.deprecation-title',
		defaultMessage: 'Legacy automation is being superseded by automation',
		description: 'Title of the section message explaining automation is being deprecated',
	},
	legacyAutomationDeprecationBody: {
		id: 'servicedesk.automation.summary.v2.deprecation-body',
		defaultMessage:
			'Legacy automation is not available in new Jira Service Management sites. Existing sites like yours, will not lose access to legacy automation and you can continue using and editing rules as you have been doing before.',
		description: 'Body of the section message explaining automation is being deprecated',
	},
	legacyAutomationIPHLink: {
		id: 'jsm.automation.summary.v2.legacy-automation-iph-link',
		defaultMessage: 'Learn more about legacy automation',
		description: 'In product help link about legacy automation',
	},
	automationBody: {
		id: 'servicedesk.automation.v2.summary.deprecation-body',
		defaultMessage:
			'We will continue adding powerful features to the newer automation tool and encourage you to start using automation for any new rules you create.',
		description: 'Body of the section message explaining automation is being deprecated',
	},
	automationIPHLink: {
		id: 'jsm.automation.summary.v2.automation-iph-link',
		defaultMessage: 'Learn more about automation',
		description: 'In product help link about Automation for Jira',
	},
	deprecationLink: {
		id: 'servicedesk.automation.v2.summary.deprecation-link',
		defaultMessage: 'Learn more',
		description: 'Link to documentation explaining the deprecation changes',
	},
});
